export function linkedRecordsSelection(route) {
  const isMemberRoute = route?.meta?.facilityScope === true
    || (route?.matched || []).some(record => record.meta?.facilityScope === true);
  if (!isMemberRoute) return {};
  const facilityId = typeof route?.params?.id === 'string' ? route.params.id.trim() : null;
  return { viewContext: 'member', facilityId: facilityId || null };
}

export function linkedRecordsCacheKey(tagId, selection = {}, companyId, userId) {
  return JSON.stringify([
    companyId || '', userId || '', tagId,
    selection.viewContext || (selection.facilityId ? 'member' : 'legacy'),
    selection.facilityId || '',
  ]);
}
